module.exports = __webpack_public_path__ + "images/f652582c6e0926294033cb98eeda9236-IMG_5061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5061.jpg
// module id = ./src/assets/images/slides/living2/IMG_5061.jpg
// module chunks = 0